import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

import type { GetTagsResponse } from '../modal/tag';

export interface GetTagsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const getTagsAPI = async (params?: GetTagsParams) => {
  const response = await baseAPI.get<GetTagsResponse>(`/tags`, {
    params: {
      ...params,
      type: 'tags',
    },
  });
  return response.data;
};

export const getTagsQueryOptions = (params?: GetTagsParams) =>
  queryOptions({
    queryKey: ['tags', params],
    queryFn: () => getTagsAPI(params),
    placeholderData: keepPreviousData,
  });

export const useGetTags = (params?: GetTagsParams) => {
  return useQuery(getTagsQueryOptions(params));
};
